import React, { Component } from 'react';
import { Input, Label, FormGroup } from 'reactstrap';
import { withLocalize } from 'react-localize-redux';

import PropTypes from 'prop-types';


class DropdownSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const options = this.props.options.map((option) => (
      <option
        value={option.en}
        key={option.en}
      >
        {this.props.activeLanguage.code === 'gb'
          ? option.en : option.fr}
      </option>
    ));

    return (
      <FormGroup>
        <Label className="sm-text" for={this.props.id}>{this.props.title}</Label>
        <Input
          id={this.props.id}
          type="select"
          value={this.props.value}
          onChange={this.props.handleChange}
        >
          <option value="">
            {this.props.activeLanguage.code === 'gb' ? 'Select an option' : 'Sélectionnez une option'}
          </option>
          {options}
        </Input>
      </FormGroup>

    );
  }
}

DropdownSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withLocalize(DropdownSelect);
